import React from 'react';
import SupportTicketListing from '../components/supportTicket/supportTicketListing/SupportTicketListing';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

function SupportTicket() {

    const canSupportTicket = hasPermission("Support Tickets", "Support Ticket", "read");
    // const canSupportTicketComment = hasPermission("Support Tickets", "", "create");
    const navigate = useNavigate();

    if (!canSupportTicket) {
        navigate('/no-permission')
    }

    return (
        <SupportTicketListing />
    )
}

export default SupportTicket;